import { jsx } from "react/jsx-runtime";
import { NumberInputFieldWUT } from "../../../ui/number-input-field/number-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const NumberInputWUT = (props) => {
  const fieldType = FIELD_TYPES.NUMBER_INPUT;
  return /* @__PURE__ */ jsx(NumberInputFieldWUT, { ...props, fieldType });
};
export {
  NumberInputWUT
};
//# sourceMappingURL=number-input-wut.js.map
